import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { UsersPurchasePlansInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  planToUpdate: UsersPurchasePlansInterface | null;
  setPlanToUpdate: React.Dispatch<React.SetStateAction<UsersPurchasePlansInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const UsersPurchasePlansUpdateDialog: React.FC<Props> = ({
  open,
  planToUpdate,
  setPlanToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update User Purchase Plan</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="User ID"
        type="number"
        value={planToUpdate?.userId ?? ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, userId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Purchase Plan ID"
        type="number"
        value={planToUpdate?.purchasePlanId ?? ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, purchasePlanId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Start Date"
        type="date"
        value={planToUpdate?.startDate ? String(planToUpdate.startDate).slice(0, 10) : ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, startDate: e.target.value } : p)}
        fullWidth
        margin="dense"
        InputLabelProps={{ shrink: true }}
        required
      />
      <TextField
        label="End Date"
        type="date"
        value={planToUpdate?.endDate ? String(planToUpdate.endDate).slice(0, 10) : ''}
        onChange={e => setPlanToUpdate(p => p ? { ...p, endDate: e.target.value } : p)}
        fullWidth
        margin="dense"
        InputLabelProps={{ shrink: true }}
        required
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={planToUpdate?.active !== undefined ? (planToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setPlanToUpdate(p => p ? { ...p, active: e.target.value === 'yes' } : p)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);